// The prompt at the top of My details and My events: the events this person worked
// that finished in the last 30 days and that they haven't given feedback on yet
// (GET /feedback/mine — the window and what counts as having worked an event are the
// server's, core/feedback.py). Shows nothing when there are none.
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Alert, AlertTitle, Box, Button, Stack, Typography } from "@mui/material";
import { API_BASE_URL } from "../config";
import { feedbackDue } from "../feedbackRules";
import StaffFeedbackDialog from "./StaffFeedbackDialog";

// `refreshKey` refetches when it changes and `onSent` reports a submission, so a page
// offering feedback elsewhere too (My events' past events) stays in step with it.
export default function FeedbackBanner({ person, refreshKey, onSent }) {
  const [due, setDue] = useState([]);
  const [open, setOpen] = useState(null);

  // Keyed on the id, so saving My details (a new `person` object) doesn't refetch.
  const personId = person?.id;
  const load = useCallback(() => {
    if (personId == null) return;
    axios.get(`${API_BASE_URL}/feedback/mine`)
      .then(res => setDue(feedbackDue(res.data)))
      .catch(() => {});
  }, [personId]);
  useEffect(load, [load, refreshKey]);

  return (
    <>
      {due.length > 0 && (
        <Alert severity="info" variant="outlined">
          <AlertTitle>How did it go?</AlertTitle>
          <Typography variant="body2" gutterBottom>
            We'd like your feedback on {due.length === 1 ? "an event" : "events"} you worked
            recently — what went well, and what we could do better.
          </Typography>
          <Stack spacing={1}>
            {due.map(e => (
              <Box key={e.event_id} sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                <Typography variant="body2" sx={{ flex: 1, minWidth: 200 }}>{e.label}</Typography>
                <Button size="small" variant="contained" onClick={() => setOpen(e)}>
                  Give feedback
                </Button>
              </Box>
            ))}
          </Stack>
        </Alert>
      )}
      <StaffFeedbackDialog event={open} person={person} onClose={() => setOpen(null)}
                           onSent={() => { load(); onSent?.(); }} />
    </>
  );
}
